const h5pQuestionFeedbackContent = () => {
    document.addEventListener("DOMContentLoaded", function () {

        function replaceOfToZ(el) {
            el.textContent = el.textContent.replace(/(\d+)\s+of\s+(\d+)/g, '$1 з $2');
        }

        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach(mutation => {
                mutation.addedNodes.forEach(node => {

                    if (node.nodeType === 1) {
                        if (node.classList.contains('h5p-question-feedback-content-text')) {
                            replaceOfToZ(node);
                        }

                        node.querySelectorAll?.('.h5p-question-feedback-content-text').forEach(el => {
                            replaceOfToZ(el);
                        });
                    }
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        document.querySelectorAll('.h5p-question-feedback-content-text').forEach(el => {
            replaceOfToZ(el);
        });

    });
};

export default h5pQuestionFeedbackContent;
